import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { LOGIN_PATH, LOGOUT_PATH, ROOT_PATH, SHORTCUT_MAIN_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

import { AntiSinGovNotice, ImportantNotices } from './pages/components';
import LoginPage from './pages/LoginPage/LoginPage';

const HomePage = lazy(() => import('./pages/HomePage/HomePage'));
const ShortcutMainPage = lazy(() => import('./pages/ShortcutMainPage/ShortcutMainPage'));
const LogoutPage = lazy(() => import('./pages/Logout/LogoutPage'));

export const HOME_ROUTES: RouteConfig[] = [
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <HomePage />,
    displayTitle: () => 'HealthHub',
    layoutProps: {
      contentClassName: undefined,
      importantNotices: <ImportantNotices />,
      noStyleContent: true,
      antiSinGovNotice: <AntiSinGovNotice />,
    },
    pageType: PageType.PUBLIC,
    path: ROOT_PATH,
    serviceCatalogCode: '',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <LoginPage />,
    displayTitle: () => 'HealthHub',
    layoutProps: {
      contentClassName: undefined,
      importantNotices: <ImportantNotices />,
      noStyleContent: true,
      antiSinGovNotice: <AntiSinGovNotice />,
    },
    pageType: PageType.PRIVATE,
    path: LOGIN_PATH,
    serviceCatalogCode: '',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ShortcutMainPage />,
    displayTitle: () => 'HealthHub',
    layoutProps: {
      contentClassName: undefined,
      importantNotices: <ImportantNotices />,
      noStyleContent: true,
      antiSinGovNotice: <AntiSinGovNotice />,
    },
    pageType: PageType.PRIVATE,
    path: SHORTCUT_MAIN_PATH,
    serviceCatalogCode: '',
  },
  {
    path: LOGOUT_PATH,
    serviceCatalogCode: '',
    component: () => <LogoutPage />,
    displayTitle: () => 'HealthHub',
    layoutProps: {
      noStyleContent: true,
      contentClassName: undefined,
      isHideFooter: true,
    },
    pageType: PageType.PUBLIC,
    availableViews: [LayoutType.COMMON],
  },
];
